module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicCondensed-Regular-90d6d8e08869926af037676737557037.woff";